import Vue from 'vue'
import App from './App.vue'
import MetaInfo from 'vue-meta-info'
import Element from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import locale from "element-ui/lib/locale/lang/zh-CN";
import scroll from 'vue-seamless-scroll'

Vue.use(scroll)
Vue.use(Element, { locale });
Vue.use(MetaInfo)
Vue.config.productionTip = false
for (const i in process.env) {
  const a = i.substr(13)
  window[a] = process.env[i]
}
new Vue({
  render: (h) => h(App),
  mounted: () => {
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
}).$mount('#app')
